export default "__VITE_ASSET__Bce23uRv__"